import { Text, Transforms, Editor } from 'slate';

const Type = 'disable-line-break';
const DisableLineBreakPlugin = _options => ({
  type: Type,
  extendEditor(editor) {
    const {
      apply,
      normalizeNode
    } = editor;
    editor.apply = operation => {
      if (operation.type === 'split_node' && operation.path.length === 1) {
        return;
      }
      apply(operation);
    };
    editor.normalizeNode = entry => {
      const [node, path] = entry;
      if (Text.isText(node)) {
        const {
          text
        } = node;
        const textWithoutLineBreaks = stripLineBreaks(text);
        if (text !== textWithoutLineBreaks) {
          Transforms.insertText(editor, textWithoutLineBreaks, {
            at: Editor.range(editor, path)
          });
          return;
        }
      }
      normalizeNode(entry);
    };
    return editor;
  },
  onKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  },
  onDOMBeforeInput(event) {
    const {
      inputType
    } = event;
    if (inputType === 'insertLineBreak') {
      event.preventDefault();
    }
  },
  deserialize: {
    before: stripLineBreaks
  },
  serialize: {
    leaf(props) {
      return stripLineBreaks(props.children);
    }
  }
});
const lineBreaksRegex = new RegExp(/\r?\n|\r/, 'g');
function stripLineBreaks(text) {
  return text.replace(lineBreaksRegex, '');
}

export { DisableLineBreakPlugin, Type };
